/**
 * The one name key (spec §4) — the browser copy of backend/services/posNameKey.js.
 *
 * The server sends `name_key` on every matched or unmatched line; use that.
 * This copy exists only as the fallback for a line that arrives without one.
 * It must behave exactly like the backend: backend/scripts/checks/
 * check-pos-name-key.js loads this file and fails on any difference.
 */

// "[Serves 1]", "(serves 2)", "[serve 1]": a delivery platform's serving tag.
const SERVING_TAG = /[[(]\s*serves?\s*\d+\s*[\])]/g;

// Letters, combining marks and digits of ANY script survive (Telugu and Hindi
// vowel signs are marks, not letters).
const NOT_LETTER_MARK_OR_DIGIT = /[^\p{L}\p{M}\p{N}]+/gu;

// A leading QUANTITY goes ("2 x", "2x", "2 nos"); a bare number stays ("65 Chicken").
const LEADING_QUANTITY = [/^\d+(?:\.\d+)?\s*x\s+/, /^\d+\s+nos\s+/];

const TOKEN_FOLDS = { vegetarian: 'veg', prawn: 'prawns', shrimp: 'prawns', shrimps: 'prawns' };

export function posNameKey(name) {
  let s = String(name ?? '').normalize('NFKC').toLowerCase();
  s = s.replace(SERVING_TAG, ' ');
  s = s.replace(/[×*]/g, ' x ').replace(/&/g, ' and ');
  s = s.replace(NOT_LETTER_MARK_OR_DIGIT, ' ').replace(/\s+/g, ' ').trim();

  let stripped = true;
  while (stripped) {
    stripped = false;
    for (const quantity of LEADING_QUANTITY) {
      const next = s.replace(quantity, '');
      if (next !== s) {
        s = next;
        stripped = true;
      }
    }
  }

  s = s.replace(/\bnon\s*vegetarian\b/g, 'nonveg');
  s = s.split(' ').map((token) => TOKEN_FOLDS[token] || token).join(' ');
  s = s
    .replace(/\bnon\s*veg\b/g, 'nonveg')
    .replace(/\bn\s+veg\b/g, 'nonveg')
    .replace(/\bnv\b/g, 'nonveg');

  return s.replace(/\s+/g, ' ').trim();
}
